<script lang="ts">
    import type {IFilterCategory} from "../../interfaces";
    import {createEventDispatcher} from "svelte";
    import CheckInput from "../atoms/CheckInput.svelte";
    import Title from "../atoms/Title.svelte";

    export let filters: Array<IFilterCategory>;
    let active = null;

    const dispatch = createEventDispatcher();

    function navigate(slug) {
        active = slug;
        filters.forEach((category) => {
            category['active'] = (category.slug === active);
        });
    }

    function reset() {
        active = null;
        filters.forEach((category) => {
            category['active'] = false;
        });
    }

    export function emitFilters(option) {
        if (option && option?.children?.length > 0) {
            option.children.forEach((child) => {
                child.active = true;
            })
        }
        const selected = [];
        const obj = {};
        filters.forEach((filter) => {
            const filtered = filter.options.filter(o => o.active);
            if (filtered?.length > 0) {
                if (!obj[filter.slug]) {
                    obj[filter.slug] = [];
                }
                obj[filter.slug].push(...filtered.map(f => f.value));
                (filtered).forEach((item) => {
                    (item?.children ?? []).forEach((child) => {
                        const f = child.options.filter(o => o.active);
                        if (f.length > 0) {
                            if (!obj[child.slug]) {
                                obj[child.slug] = [];
                            }
                            obj[child.slug].push(...f.map(_ => _.value));
                        }
                    });
                })
            }
        });
        Object.keys(obj).forEach((key: string) => {
            selected.push({
                slug: key,
                options: obj[key].reduce((acc, item) => {
                    if (!acc.find(i => i === item)) {
                        acc.push(item);
                    }
                    return acc;
                }, [])
            });
        });
        dispatch('filtered', selected)
    }
</script>
<div>
    {#if !active}
        {#each filters as cat (cat.slug)}
            <div class="border-bottom box-b py-1 filter-category pointer" on:click={navigate.bind(this, cat.slug)}>
                <p>{cat.label}</p>
                <div>
                    <img height="20" src="/static/storefront/pix/icons/chevron-gray.svg" alt="Chevron gray">
                </div>
            </div>
        {/each}
    {:else}
        {#each filters as cat (cat.slug)}
            {#if cat.active}
                <div class="py-iii">
                    <Title title="{cat.label}" on:click={reset}/>
                    <br>
                    <div>
                        {#each cat.options as option (option.value)}
                            <CheckInput label="{option.label}" bind:active="{option.active}"
                                        on:changes={()=>emitFilters(option)}/>
                            {#if option.active && option.children?.length > 0}
                                <div class="pl-1">
                                    {#each option.children as child}
                                        <div>
                                            <div class="flex mt-iii sx-ii" style="align-items: center">
                                                {#if child.active}
                                                    <div class="pointer" on:click="{()=>child.active=false}">
                                                        <img height="15"
                                                             style="transform: rotate(180deg);"
                                                             src="/static/storefront/pix/icons/chevron-gray.svg"
                                                             alt="Chevron gray">
                                                    </div>
                                                {/if}
                                                <h4 style="font-weight: 500">
                                                    {child.label}
                                                    {#if child.options.filter(o => !!o.active)?.length > 0}
                                                        ({child.options.filter(o => !!o.active)?.length})
                                                    {/if}
                                                </h4>
                                                {#if !child.active}
                                                    <div class="pointer" on:click="{()=>child.active=true}">
                                                        <img height="15"
                                                             src="/static/storefront/pix/icons/chevron-gray.svg"
                                                             alt="Chevron gray">
                                                    </div>
                                                {/if}
                                            </div>
                                            {#if child.active}
                                                {#each child.options as opt (opt.value)}
                                                    <CheckInput label="{opt.label}"
                                                                bind:active="{opt.active}"
                                                                on:changes={emitFilters}/>
                                                {/each}
                                            {/if}
                                        </div>
                                    {/each}
                                </div>
                            {/if}
                        {/each}
                    </div>
                </div>

            {/if}
        {/each}
    {/if}


</div>
<style>
    .filter-category:active {
        background: var(--bg-gray);
    }
</style>